import { api } from "api/apiService";

/**
 * Завантажує повний список категорій з CRM.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами категорій.
 */
export const fetchCrmCategories = () => {
  return api.get("/categories");
};
